import agents from '@/config/nav/agents'
import agentSettings from '@/config/nav/agentSettings'
import automation from '@/config/nav/automation'
import customers from '@/config/nav/customers'
import dashboard from '@/config/nav/dashboard'
import leads from '@/config/nav/leads'
import messages from '@/config/nav/messages'
import orders from '@/config/nav/orders'
import reports from '@/config/nav/reports'
import resellers from '@/config/nav/resellers'
import sell from '@/config/nav/sell'

export const SECTION_NAV = {
  Dashboard: dashboard,
  Leads: leads,
  Orders: orders,
  Messages: messages,
  Customers: customers,
  Resellers: resellers,
  Sell: sell,
  Automation: automation,
  'AI Agents': agents,
  'Agent settings': agentSettings,
  Reports: reports
}

export const sectionNav = name => SECTION_NAV[name]
